import { ComponentProps, ReactNode } from 'react';
import { Label } from '@givebutter/primitives/label';
import { useWidgetFormContext } from 'components/form/WidgetFormContext';
import { twMerge } from 'tailwind-merge';

interface FormFieldProps extends ComponentProps<'div'> {
  label?: ReactNode;
  labelId?: string;
  htmlFor?: string;
  description?: ReactNode;
  error?: string;
  errorId?: string;
}

export const FormField = ({
  label,
  labelId,
  htmlFor,
  description,
  error,
  errorId,
  children,
  className,
  ...rest
}: FormFieldProps) => {
  const { compact } = useWidgetFormContext();
  return (
    <div className={twMerge('flex flex-col gap-1.5', className)} {...rest}>
      {label && (
        <Label
          id={labelId}
          htmlFor={htmlFor}
          className={twMerge(
            'text-sm',
            compact ? 'font-normal text-gray-600' : 'font-medium text-gray-900',
          )}
        >
          {label}
        </Label>
      )}
      {children}
      {description && <p className="text-xs text-gray-500">{description}</p>}
      {error && (
        <p id={errorId} className="text-xs text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
